module.exports = __webpack_public_path__ + "img/universal960x640.a95095a9.jpg";